<template>
  <!-- Card 17trt6jbjf2 (retorno de 14/10): "Planejamento de aula" — anotação
       privada do professor sobre a turma, na Visão geral. Substitui as
       observações por aula da aba Presença (o texto delas foi trazido para
       cá, com a data de cada aula). -->
  <section class="class-plan mt-6">
    <div class="class-plan__head">
      <v-icon small :color="theme.primary" class="mr-2">
        mdi-clipboard-text-outline
      </v-icon>
      <span class="class-plan__title">{{ $t("classPlan.title") }}</span>
      <v-icon x-small color="#94a3b8" class="ml-2">mdi-lock-outline</v-icon>
    </div>
    <div class="class-plan__hint">
      {{ $t("classPlan.hint") }}
    </div>

    <v-textarea
      v-model="draft"
      class="mt-3"
      outlined
      auto-grow
      rows="4"
      :counter="maxLength"
      :maxlength="maxLength"
      :placeholder="$t('classPlan.placeholder')"
      :loading="loading"
      :disabled="loading"
      hide-details="auto"
    />

    <div class="d-flex flex-wrap justify-end align-center mt-2">
      <div v-if="dirty" class="caption mr-4 class-plan__muted">
        {{ $t("classPlan.unsaved") }}
      </div>
      <div v-else-if="updatedAt" class="caption mr-4 class-plan__muted">
        {{ $t("classPlan.savedAt", { date: formatDateTime(updatedAt) }) }}
      </div>
      <v-btn
        rounded
        outlined
        :color="theme.primary"
        :loading="saving"
        :disabled="!dirty || loading"
        @click="save"
      >
        {{ $t("classPlan.save") }}
      </v-btn>
    </div>
  </section>
</template>

<script>
import partnerApi from "@/shared/pitchPartnerApi";
import { languageTag } from "@/plugins/i18n";

const SCHOOL_TIME_ZONE = "America/Sao_Paulo";

export default {
  name: "ClassPlanCard",

  props: {
    groupId: {
      type: [String, Number],
      required: true,
    },
    theme: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      maxLength: 10000,
      saved: "",
      draft: "",
      updatedAt: null,
      loading: false,
      saving: false,
    };
  },

  computed: {
    dirty() {
      return (this.draft || "").trim() !== (this.saved || "").trim();
    },
  },

  watch: {
    groupId: {
      immediate: true,
      handler() {
        this.load();
      },
    },
  },

  methods: {
    apply(data) {
      this.saved = data?.plan || "";
      this.draft = this.saved;
      this.updatedAt = data?.updatedAt || null;
    },
    async load() {
      this.loading = true;
      try {
        const res = await partnerApi.getClassPlan(this.groupId);
        this.apply(res.data);
      } catch (error) {
        this.$root.$emit("display-alert", {
          text: this.$t("classPlan.loadFailed"),
          type: 1,
        });
      } finally {
        this.loading = false;
      }
    },
    async save() {
      this.saving = true;
      try {
        const res = await partnerApi.saveClassPlan(
          this.groupId,
          (this.draft || "").trim()
        );
        this.apply(res.data);
        this.$root.$emit("display-alert", {
          text: res.data?.plan
            ? this.$t("classPlan.saved")
            : this.$t("classPlan.removed"),
          type: 0,
        });
      } catch (error) {
        this.$root.$emit("display-alert", {
          text:
            error?.response?.data?.message || this.$t("classPlan.saveFailed"),
          type: 1,
        });
      } finally {
        this.saving = false;
      }
    },
    formatDateTime(value) {
      const date = value ? new Date(value) : null;
      if (!date || Number.isNaN(date.getTime())) return "-";

      return new Intl.DateTimeFormat(languageTag(), {
        day: "2-digit",
        month: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: SCHOOL_TIME_ZONE,
      }).format(date);
    },
  },
};
</script>

<style scoped>
.class-plan {
  padding: 16px 18px;
  border-radius: 16px;
  border: 1px solid rgba(var(--dk-ink-rgb, 35, 26, 46), 0.09);
  background: var(--dk-surface, #ffffff);
}

.class-plan__head {
  display: flex;
  align-items: center;
}

.class-plan__title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--dk-ink, #231a2e);
}

.class-plan__hint,
.class-plan__muted {
  color: var(--dk-muted, #6b6472);
  font-size: 0.85rem;
}

.class-plan__hint {
  margin-top: 2px;
}
</style>
